/**
 * Утилиты для работы с видеокомнатами
 */

/**
 * Добавляет параметры участника к URL видеокомнаты
 * @param {string} roomUrl - URL видеокомнаты
 * @param {string} currentLanguage - текущий язык интерфейса ('ru' или 'kk')
 * @param {string} [username] - имя пользователя для подстановки в видеосервис
 * @param {string} [role] - роль участника в видеосервисе ('doctor' или 'patient')
 * @returns {string} URL с добавленными параметрами
 */
export function addLanguageToVideoRoomUrl(roomUrl, currentLanguage, username, role) {
  try {
    const url = new URL(roomUrl);

    url.searchParams.set('lang', currentLanguage === 'kk' ? 'kk' : 'ru');

    if (username) {
      url.searchParams.set('username', username);
    }

    if (role === 'doctor' || role === 'patient') {
      url.searchParams.set('role', role);
    }

    return url.toString();
  } catch (error) {
    // Возвращаем оригинальный URL в случае ошибки
    return roomUrl;
  }
}

/**
 * Собирает URL видеокомнаты с параметрами lang, username и role
 * @param {string} roomUrl - URL видеокомнаты
 * @param {string} currentLanguage - текущий язык интерфейса ('ru' или 'kk')
 * @param {string} [username] - имя пользователя для подстановки в видеосервис
 * @param {string} [role] - роль участника в видеосервисе ('doctor' или 'patient')
 * @returns {string} готовый URL
 */
export function buildVideoRoomUrl(roomUrl, currentLanguage, username, role) {
  return addLanguageToVideoRoomUrl(roomUrl, currentLanguage, username, role);
}

/**
 * Открывает видеокомнату в новом окне с параметрами участника
 * @param {string} roomUrl - URL видеокомнаты
 * @param {string} currentLanguage - текущий язык интерфейса ('ru' или 'kk')
 * @param {string} [username] - имя пользователя
 * @param {string} [role] - роль участника в видеосервисе ('doctor' или 'patient')
 */
export function openVideoRoomWithLanguage(roomUrl, currentLanguage, username, role) {
  const urlWithParams = addLanguageToVideoRoomUrl(roomUrl, currentLanguage, username, role);
  window.open(urlWithParams, '_blank', 'noopener,noreferrer');
}
